function getError(action, option, xhr) {
  let msg;
  if (xhr.response) {
    msg = `${xhr.response.error || xhr.response}`;
  } else if (xhr.responseText) {
    msg = `${xhr.responseText}`;
  } else {
    msg = `fail to post ${action} ${xhr.status}`;
  }
  const err = new Error(msg);
  err.status = xhr.status;
  err.method = 'post';
  err.url = action;
  return err;
}

export default function uploadrequest(option) {
  if (typeof XMLHttpRequest === 'undefined') {
    return;
  }
  const xhr = new XMLHttpRequest();
  const action = option.url;

  // const formData = new FormData();
  // if (option.data) {
  //   Object.keys(option.data).forEach(key => {
  //     formData.append(key, option.data[key]);
  //   });
  // }
  // formData.append(option.filename, option.file, option.file.name);

  if (xhr.upload) {
    xhr.upload.onprogress = e => {
      if (e.total > 0) {
        e.percent = e.loaded / e.total * 100;
      }
      option.onProgress.call(option.thischunk,e);
    };
  }
  xhr.onerror = (e) => {
    option.onError.call(option.thischunk,e);
  };
  xhr.onload = e => {
    if (xhr.status < 200 || xhr.status >= 300) {
      return option.onError(getError(action, option, xhr));
    }
    option.onSuccess.call(option.thischunk);
  };
  xhr.open('put', action, true);
  if (option.withCredentials && 'withCredentials' in xhr) {
    xhr.withCredentials = true;
  }

  const headers = option.headers || {};

  for (let item in headers) {
    if (headers.hasOwnProperty(item) && headers[item] !== null) {
      xhr.setRequestHeader(item, headers[item]);
    }
  }
  xhr.setRequestHeader("Content-Type", "touchsprite/uploadfile")
  xhr.send(option.file);
  return xhr;
}
